"use client";
import { useState } from "react";
import { IoAdd, IoRemove } from "react-icons/io5";

function QuestionAnswer({ content, isMerchant }) {
  const [openAns, setOpenAns] = useState([]);
  const isOpen = openAns.includes(content.id);
  const handleShowAns = (id) => {
    setOpenAns((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };
  return (
    <li className="font-medium text-[1rem]">
      <div
        className={`${
          isMerchant ? "bg-primary-bgBlue" : "bg-[#FFF6D0]"
        }  p-5  flex justify-between items-center cursor-pointer ${
          isOpen ? "rounded-[10px_10px_0_0]" : "rounded-[10px]"
        }`}
        onClick={() => handleShowAns(content.id)}
      >
        <p>
          <span className="mr-2">Q</span>
          {content.question}
        </p>
        <button
          type="button"
          className=" border-black border-[2px] rounded-full bg-white"
          aria-label="toggle answer"
        >
          {isOpen ? (
            <IoRemove size={28} color="black" />
          ) : (
            <IoAdd size={28} color="black" />
          )}
        </button>
      </div>

      <div
        className={`bg-white px-5 rounded-[0_0_10px_10px] flex leading-[1.8] overflow-hidden transition-all duration-300${
          isOpen ? "max-h-96 opacity-100 py-5" : " max-h-0 opacity-0 "
        }`}
      >
        <span
          className={`mr-2 ${
            isMerchant ? "text-primary-blue" : "text-primary-orange"
          }`}
        >
          A
        </span>
        {content.id === 13 ? (
          <ol className="pl-6">
            <li className="list-decimal">
              發佈後，您只能調整招募人數，無法更改其他工作細節。
            </li>
            <li className="list-decimal mb-1">
              發佈的工作需求可以取消，但根據取消的時間，平台將扣除部分工資並補償工作者。請注意，取消已媒合的工作會影響您的商家評價，因此我們不建議在工作者已經被媒合後取消。
            </li>
            <p>取消工時規則：</p>
            <ul className="list-disc pl-4">
              <li>上工前48-24小時取消： 不扣工資</li>
              <li>上工前24-12小時取消： 扣除30%工資</li>
              <li>上工前12-2小時取消： 扣除50%工資</li>
            </ul>
          </ol>
        ) : content.id === 14 ? (
          <ol className="pl-6">
            <li className="list-decimal mb-1">
              若工作者遲到並提交遲到申請，您可以選擇同意或拒絕申請：
              <ul className="list-disc pl-4">
                <li>
                  同意申請：工作者會在15分鐘內抵達，且工作者的下班時間會根據遲到時間順延。
                </li>
                <li>
                  拒絕申請：工作者將被取消工作，並對已事先支付的薪資進行全額退款。
                </li>
              </ul>
            </li>
            <li className="list-decimal">
              若工作者因遲到被系統或商家取消，則平台會在結算後對已支付的薪資進行全額退款。
            </li>
          </ol>
        ) : (
          <p>{content.answer}</p>
        )}
      </div>
    </li>
  );
}

export default QuestionAnswer;
